import { fetch, buildUrl } from 'domain/Api';
import {
  fetchStudentReportSummaryIfNeeded,
} from 'data/ProgressReports/StudentReportSummaries/actions';
import { ApiCall } from 'omni-common-ui';

export const REJECT_STUDENT_REPORT_REQUEST = 'REJECT_STUDENT_REPORT_REQUEST';
export const REJECT_STUDENT_REPORT_SUCCESS = 'REJECT_STUDENT_REPORT_SUCCESS';
export const REJECT_STUDENT_REPORT_FAILURE = 'REJECT_STUDENT_REPORT_FAILURE';

export function rejectStudentReport(note, progressReportId, studentReportId) {
  return (dispatch, getState) => {
    const userId = getState()
        .get('singleSignOn')
        .get('user')
        .get('profile')
        .sub;
    const url = buildUrl(`/unit-reports/${progressReportId}/dos-rejects`);
    const method = 'PUT';

    return dispatch(rejectStudentReportRequest()).payload
      .then((response) => dispatch(rejectStudentReportSuccess(response)))
      // So that the report summary information gets updated
      .then(() => dispatch(fetchStudentReportSummaryIfNeeded(progressReportId, studentReportId)))
      .catch((error) => dispatch(rejectStudentReportFailure(error)));

    function rejectStudentReportRequest() {
      const payload = fetch(url, {
        method,
        body: JSON.stringify({
          studentReportId: Number.parseInt(studentReportId, 10),
          rejectedBy: Number.parseInt(userId, 10),
          rejectedComment: note,
        }),
      });

      return ApiCall.createAction({
        type: REJECT_STUDENT_REPORT_REQUEST,
        payload,
        url,
        method,
      });
    }

    function rejectStudentReportSuccess(payload) {
      return ApiCall.createAction({
        type: REJECT_STUDENT_REPORT_SUCCESS,
        payload,
        url,
        method,
      });
    }

    function rejectStudentReportFailure(error) {
      return ApiCall.createAction({
        type: REJECT_STUDENT_REPORT_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/ProgressReports/RejectByDos/actions.js